import React, { Component } from 'react';
import FrameComponents from "../../FrameComponents"; 

class indexNew extends Component {
  state = {};

  render() {
    return (
      <FrameComponents name="ContentAuditDetail" />
    );
    
  }
}

export default indexNew;
